<template>
  <div class="index">
    <img src="./img/top.png" alt="" />
    <div class="top">
      <div class="text">公司介绍</div>
      <div class="content">
        <div class="left">
          <img src="./img/hezuo.png" alt="" />
        </div>
        <div class="words">
          杭州图景网络技术有限公司，成立时间2009年4月22日，是一家掌握国内领先GIS技术（地理空间信息技术）的国家级高新技术企业。公司团队独立研发的二三维一体化GIS平台，是基于行业领先的地理信息、数字应用、定位技术，将互联网集成于一体的核心系统。
        </div>
      </div>
    </div>
    <div class="map">
      <img src="./img/map.png" alt="" />
      <div class="info">
        <div class="add">
          <span class="add_top">杭州市西湖区教工路18号</span>
          <span class="add_bottom">EAC欧美中心A座C区805、807、809</span>
        </div>
        <div class="bottom">0571-88223392</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.index {
  position: relative;

  img {
    width: 100%;
    display: block;
  }

  .top {
    width: 100%;
    max-width: 100%;
    min-height: 710px;
    margin: 0 auto;
    padding: 67px clamp(20px, 6vw, 120px) 80px;
    box-sizing: border-box;
    background: #ffffff;

    .text {
      margin: 0;
      text-align: center;
      font-size: clamp(28px, 2.6vw, 44px);
      font-family: 'PingFang';
      font-weight: 600;
      color: #333333;
    }

    .content {
      display: grid;
      grid-template-columns: minmax(280px, 658px) minmax(0, 1fr);
      gap: clamp(28px, 4vw, 54px);
      align-items: center;
      margin-top: 85px;

      .left {
        img {
          width: 100%;
          max-width: 658px;
          height: auto;
        }
      }

      .words {
        margin: 0;
        background: #ffffff;
        font-size: clamp(16px, 1.2vw, 20px);
        font-family: 'PingFang';
        font-weight: 400;
        line-height: 2;
      }
    }
  }

  .map {
    position: relative;
    min-height: 560px;

    img {
      width: 100%;
      min-height: 560px;
      object-fit: cover;
    }

    .info {
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: calc(100% - 32px);
      max-width: 550px;
      min-height: 250px;
      top: 50%;
      right: clamp(16px, 6vw, 80px);
      transform: translateY(-50%);
      padding: 24px 28px;
      box-sizing: border-box;
      font-size: clamp(24px, 2vw, 40px);
      color: #fff;
      border-radius: 40px;
      background-color: rgba(102, 115, 150, 0.8);

      .add {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;

        .add_bottom {
          font-size: 25px;
          margin-top: 16px;
          text-align: center;
        }
      }

      .bottom {
        font-size: 25px;
      }
    }
  }
}

@media (max-width: 900px) {
  .index .top .content {
    grid-template-columns: 1fr;
    margin-top: 48px;
  }

  .index .top .content .left {
    justify-self: center;
    width: 100%;
  }

  .index .map {
    min-height: 480px;
  }

  .index .map img {
    min-height: 480px;
  }

  .index .map .info {
    left: 16px;
    right: 16px;
    width: auto;
  }
}

@media (max-width: 640px) {
  .index .top {
    padding: 48px 16px 56px;
  }

  .index .top .content {
    gap: 24px;
  }

  .index .top .content .words {
    line-height: 1.8;
  }

  .index .map {
    min-height: 420px;
  }

  .index .map img {
    min-height: 420px;
  }

  .index .map .info {
    min-height: 190px;
    padding: 20px 18px;
    border-radius: 24px;
  }

  .index .map .info .add .add_bottom,
  .index .map .info .bottom {
    font-size: 16px;
  }
}
</style>
